export const generateFooterCopyright = () => {
    const thisYear = new Date().toISOString().split('-')[0]
    return "Tudor John & Co. LLC © 2022-" + thisYear
}